import React from "react";
import PropTypes from "prop-types";

const StructuredData = (props) => {
    let structuredData = {
        "@context": "https://schema.org",
        "@type": props.type,
    };
    Object.assign(structuredData, props.data);
    let scriptTag = `${JSON.stringify(structuredData)}`;
    return (
        <script type="application/ld+json" dangerouslySetInnerHTML={{__html: scriptTag}}></script>
    );
};
StructuredData.propTypes = {
    type: PropTypes.string,
    data: PropTypes.object,
};

export default StructuredData;
